import React, {useEffect, useState} from 'react';
// import {useSelector} from 'react-redux';
// import {RootState} from '../../typings/shared';
import SideNavigationBar from '../Components/SideNavigationBar';
import CertificationPage from './StaticPage/Certification'
import AdditionalPage from './StaticPage/Additional'
import './index.scss';
import IndexEpic from "../../epics/indexEpic";
import {DispatchProp, useSelector, useDispatch} from 'react-redux'
import {IRootState, IIndexStateType} from '../../typings/shared';
import DOMPurify from 'dompurify';
import CrossImg from './cross.png';
import HamburgerImg from './hamburger.png';
import clsx from 'clsx';

enum PageView {
    AdditionalPage = "AdditionalPage",
    CertificationPage = "CertificationPage"
}

type FCProps = {
    // sayHello: (msg: string) => void,
    // sayBye: (msg: string) => void,
    // togglePublish: () => void
}

type IndexPageProps = IIndexStateType & FCProps & DispatchProp;

const Index: React.FC<IndexPageProps> = (props) => {

    const [page, setPage] = useState("");
    const [mobileClicked, setMobileClicked] = useState(false);

    const dispatch = useDispatch();

    const {id, term_id, version, files, content}: IIndexStateType = useSelector((state: IRootState) => {
        return {
            ...state.index
        }
    });

    console.log(term_id, version, files);

    useEffect(() => {
        !id && dispatch(IndexEpic.actions.fetchContent(""));
    }, [id, dispatch]);

    const handleClick = (node) => {
        // console.log("here we go ", node);
        if(node.anchor){
            setMobileClicked(false);
            let anchorDom = document.getElementById(node.id);
            let offset: number = ((anchorDom || {}).offsetTop || 0)-32;
            window.scroll(0, offset)
        }
        if (node.inHouse) {
            setPage("");
            dispatch(IndexEpic.actions.fetchContent(node.id));
        } else if (node.page) {
            setPage(node.page)
        }

    };

    const renderContent = () => {
        if (page === PageView.CertificationPage) {
            return <CertificationPage/>
        }
        if (page === PageView.AdditionalPage) {
            return <AdditionalPage/>
        }
        const createSanitizedContent = (content) => {
            return {__html: DOMPurify.sanitize(content)}
        };
        return <div dangerouslySetInnerHTML={createSanitizedContent(content)}/>
    };

    const handleMobileClick = () => {
        setMobileClicked(!mobileClicked)
    };

    return (
        <div>
            <div className="app-bar">
                <div className="container flex-center">
                    <div className="width-25 h-12 flex-center mobile-full-width mobile-flex-align-center">Cisco DevNet
                        Terms of Service
                    </div>
                    <div
                        className="width-75 flex-center flex-justify-end color-primary-blue cursor-pointer mobile-hidden">Download
                    </div>
                    <img src={mobileClicked ? CrossImg : HamburgerImg} alt="HamburgerImg" onClick={handleMobileClick} className={"hidden mobile-show"}/>
                </div>
                <div className="border-b-2"/>
            </div>
            <div className="container" id="container">
                <div className="flex">
                    <div className={clsx({"open": mobileClicked, "width-25 frame-left": true})}>
                        <SideNavigationBar handleClick={handleClick}/>
                    </div>
                    <div className="width-75 frame-right">
                        <div className="terms-content-container">
                            {renderContent()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
